import DropdownOption from './DropdownOption'

export default class CreateSpaceVariableRequest {
  variableName!: string
  displayLabel?: string
  variableType!: string
  defaultValue?: string
  dateFormat?: string
  options?: DropdownOption[]
}
